module.exports = {"141030100":"昕水镇","141030101":"曲峨镇","141030200":"三多乡","141030201":"太德乡","141030202":"徐家垛乡","141030203":"太古乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/141030.json
// module id = 371
// module chunks = 0